/* Dysius — theme scripts */
(function () {
  'use strict';

  /* Mobile navigation toggle */
  var toggle = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('[data-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* Product gallery swipe/carousel */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var track = gallery.querySelector('[data-gallery-track]');
    if (!track) return;
    var slides = track.querySelectorAll('.product__gallery-slide');
    var prevBtn = gallery.querySelector('[data-gallery-prev]');
    var nextBtn = gallery.querySelector('[data-gallery-next]');
    var dots = gallery.querySelectorAll('[data-gallery-dot]');

    function currentIndex() {
      var scrollLeft = track.scrollLeft;
      var closest = 0, closestDist = Infinity;
      slides.forEach(function (slide, i) {
        var dist = Math.abs(slide.offsetLeft - scrollLeft);
        if (dist < closestDist) { closestDist = dist; closest = i; }
      });
      return closest;
    }

    function goTo(index) {
      if (index < 0) index = 0;
      if (index >= slides.length) index = slides.length - 1;
      track.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });
    }

    function updateDots() {
      var idx = currentIndex();
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === idx);
      });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(currentIndex() - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(currentIndex() + 1); });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () { goTo(parseInt(dot.dataset.index, 10)); });
    });

    var scrollTimer;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(updateDots, 100);
    });
  });

  /* Header search toggle */
  var searchToggle = document.querySelector('[data-search-toggle]');
  var searchBar = document.querySelector('[data-search-bar]');
  if (searchToggle && searchBar) {
    searchToggle.addEventListener('click', function () {
      var open = searchBar.classList.toggle('is-open');
      searchToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        var input = searchBar.querySelector('input[type="search"]');
        if (input) input.focus();
      }
    });
  }

  /* Variant (size) picker on the product page */
  document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
    var form = picker.closest('form');
    if (!form) return;
    var idInput = form.querySelector('[data-variant-id]');
    var priceEl = document.querySelector('[data-variant-price]');
    var submit = form.querySelector('[data-add-button]');
    var checkoutBtn = form.querySelector('[data-checkout-button]');

    picker.querySelectorAll('button[data-variant]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        picker.querySelectorAll('button[data-variant]').forEach(function (b) {
          b.setAttribute('aria-pressed', 'false');
        });
        btn.setAttribute('aria-pressed', 'true');
        if (idInput) idInput.value = btn.dataset.variant;
        if (priceEl && btn.dataset.price) priceEl.textContent = btn.dataset.price;
        var available = btn.dataset.available === 'true';
        if (submit) {
          submit.disabled = !available;
          submit.textContent = available ? submit.dataset.labelAdd : submit.dataset.labelSold;
        }
        if (checkoutBtn) checkoutBtn.disabled = !available;
      });
    });
  });

  /* Add to cart (AJAX) — "Add to bag" stays on the page, "Proceed to checkout" redirects to the bag */
  document.querySelectorAll('[data-add-button]').forEach(function (addBtn) {
    var form = addBtn.closest('form');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var submitter = e.submitter || addBtn;
      var goToCheckout = submitter.hasAttribute('data-checkout-button');
      var originalText = submitter.textContent;
      submitter.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (err) { return Promise.reject(err); });
          return res.json();
        })
        .then(function () {
          if (goToCheckout) {
            window.location.href = '/cart';
            return;
          }
          return fetch('/cart.js')
            .then(function (res) { return res.json(); })
            .then(function (cart) {
              var cartCount = document.querySelector('.header__cart-count');
              if (cart.item_count > 0) {
                if (cartCount) {
                  cartCount.textContent = cart.item_count;
                } else {
                  var cartLink = document.querySelector('.header__cart');
                  if (cartLink) {
                    var span = document.createElement('span');
                    span.className = 'header__cart-count';
                    span.textContent = cart.item_count;
                    cartLink.appendChild(span);
                  }
                }
              }
              submitter.textContent = 'Added!';
              setTimeout(function () {
                submitter.textContent = originalText;
                submitter.disabled = false;
              }, 1500);
            });
        })
        .catch(function (err) {
          console.error('Add to cart failed', err);
          submitter.textContent = originalText;
          submitter.disabled = false;
        });
    });
  });

  /* Release countdown */
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var target = new Date(el.dataset.countdown).getTime();
    if (isNaN(target)) return;

    var out = {
      days: el.querySelector('[data-cd-days]'),
      hours: el.querySelector('[data-cd-hours]'),
      minutes: el.querySelector('[data-cd-minutes]'),
      seconds: el.querySelector('[data-cd-seconds]')
    };

    function pad(n) { return n < 10 ? '0' + n : String(n); }

    function tick() {
      var diff = target - Date.now();
      if (diff <= 0) {
        el.classList.add('is-done');
        if (out.days) out.days.textContent = '00';
        if (out.hours) out.hours.textContent = '00';
        if (out.minutes) out.minutes.textContent = '00';
        if (out.seconds) out.seconds.textContent = '00';
        clearInterval(timer);
        return;
      }
      var s = Math.floor(diff / 1000);
      if (out.days) out.days.textContent = pad(Math.floor(s / 86400));
      if (out.hours) out.hours.textContent = pad(Math.floor(s % 86400 / 3600));
      if (out.minutes) out.minutes.textContent = pad(Math.floor(s % 3600 / 60));
      if (out.seconds) out.seconds.textContent = pad(s % 60);
    }

    var timer = setInterval(tick, 1000);
    tick();
  });

  /* Cart quantity live update */
  var cartUpdateSeq = 0;

  function updateCartLine(key, quantity, el) {
    var seq = ++cartUpdateSeq;
    if (el) el.disabled = true;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (res) { return res.json(); })
      .then(function () {
        if (seq !== cartUpdateSeq) return;
        window.location.reload();
      })
      .catch(function (err) {
        console.error('Cart update failed', err);
        if (seq === cartUpdateSeq && el && el.isConnected) el.disabled = false;
      });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target.closest('[data-cart-qty]');
    if (!input) return;
    e.preventDefault();
    input.blur();
    input.focus();
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-qty]');
    if (!input) return;

    var quantity = parseInt(input.value, 10);
    if (isNaN(quantity) || quantity < 0) quantity = 0;
    updateCartLine(input.dataset.key, quantity, input);
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-remove]');
    if (!btn) return;
    e.preventDefault();
    updateCartLine(btn.dataset.key, 0, btn);
  });
})();
